import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';

import { MainFooter } from './components/MainFooter';
import { NuxFooter } from './components/NuxFooter';

const Footer = observer((): JSX.Element => {
  const location = useLocation();

  const isNux = (): boolean => location.pathname.startsWith('/sitter/registration') || location.pathname.startsWith('/family-reg');;

  return (
    <footer className='mt-auto bg-neutral-900 text-white py-5 text-xs'>
      {isNux() ? <NuxFooter /> : <MainFooter />}
    </footer>
  );
});

export default Footer;
